function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "face-icon"
}, React.createElement("path", {
  fill: "currentColor",
  d: "M52.8,7.7c3,3.8-3.199,9-12.3,13c-6.122,2.387-12.628,3.641-19.2,3.7c0,0,1.7-16.2,12.5-19.4 C43.3,2,49.8,4,52.8,7.7z M11.3,1.5V0H0v12.5h1.5v-11H11.3z"
}), React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  d: "M29.3,53c0.301,4,0.601,8.4,0,11c-1,3.7-10,4.5-17.699,5.601L4.2,71  M78,71.8l-7.3-1.3C63,69.3,54,68.5,53,65c-0.6-2.8-0.3-7,0-11.2 M56.4,9.5C57.739,18.365,40.9,25,21.2,25 M48.6,49.3 c0.082,0.073,0.091,0.2,0.018,0.282c-0.006,0.007-0.012,0.013-0.018,0.019c-1.902,1.801-4.384,2.865-7,3c-3.4,0-6-2.301-7-3 c0,0,0-0.301,0.199-0.301l4-1.3c0.448-0.188,0.953-0.188,1.4,0l1.5,0.4L43,48c0.638-0.278,1.362-0.278,2,0L48.6,49.3z"
}), React.createElement("path", {
  fill: "currentColor",
  d: "M34.7,49.5l6.8,0.7l7-0.8"
}), React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  d: "M41.6,60.7c-3.7,0-7.2-3-9.801-5.4c-3.6-3.3-5.5-5-8-11.8 c-1.157-4.017-1.928-8.136-2.3-12.3c-2-19,8-27.5,19.5-27.6h0.5"
}), React.createElement("circle", {
  fill: "currentColor",
  cx: 32.443,
  cy: 30.711,
  r: 1.1
}), React.createElement("circle", {
  fill: "currentColor",
  cx: 51,
  cy: 31,
  r: 1.1
}), React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  d: "M53.5,15.4C54,20.2,58.8,25,62,25.6 M41.6,60.6c3.8,0,7.3-3,10-5.301 c3.5-3.3,5.399-5,7.8-11.8c1.26-4.007,2.13-8.126,2.6-12.3c2.2-19-8-27.5-19.5-27.6H42 M22,35.3c-3-1.5-3.7-7-0.8-8 M61.2,35 c3-1.6,4-7.2,1-8 M41.7,3.5h-1"
}), React.createElement("path", {
  fill: "currentColor",
  d: "M82.31,1.6v11h1.5V0h-11.3v1.5h9.8V1.6z M72.5,86.3v1.4h11.3V75.2h-1.5v11h-9.8V86.3z M2.5,86V75.2h-2v12.5 H12v-1.5L2.5,86z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M21.392,26.933c0,0,27.108-2.533,30.708-9.37c0,0,2.639,6.837,9.899,8.037c0,0,0-22-19.5-22 c-15.118,0-21.426,12.099-21.256,18.098C21.392,26.933,21.392,26.933,21.392,26.933z"
});

var SvgFace = function SvgFace(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "83.811px",
    height: "89.73px",
    viewBox: "0 0 83.811 89.73",
    enableBackground: "new 0 0 83.811 89.73",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/face.04718240.svg";
export { ForwardRef as ReactComponent };